<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <th
    data-slot="table-head"
    :class="
      cn(
        'text-foreground bg-accent h-10 px-3 text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        props.class
      )
    "
  >
    <slot />
  </th>
</template>
